import React,{useState} from 'react'
import { Routes, Route, Link } from 'react-router-dom';
import Summer_2022 from '../2022/Summer_2022'
import Summer_2021 from '../2021/Summer_2021'
import Summer_2023 from '../2023/Summer_2023'
import Summer_2020 from '../2020/Summer_2020'
import Summer_2024 from '../2024/Summer_2024';
import spdata2022 from '../2022/Summer_Intern_data_2022'
// import spdata2023 from '../2023/Summer_Internship_data_2023'
import spdata2023 from '../2023/Summer_Intern_data_2023';
import spdata_2024 from '../2024/Summer_Intern_data_2024';
import spdata_2021 from '../2021/Summer_Intern_data_2021';
import spdata2020 from '../2020/Summer_Intern_data_2020';






const Summer = () => {
  
  


  return (

    <div>
       <div className='myheader'>
        <button className='merabtn'>
          <span>Summer Internship</span><i></i>
      </button>
        </div>

      
  
        <div> 

        <div className='myclass'>

              <Link to="/sp/2024">
                  <div className='menuLink'>
                  2024
                  </div>
              </Link>
             
            <Link to="/sp/2023">
                <div className='menuLink'>
                2023
                </div>
            </Link>

            <Link to="/sp/2022">
                <div className='menuLink'>
                    2022
                </div>               
            </Link>

            <Link to="/sp/2021"> 
              <div className='menuLink'>
                2021
              </div>
            </Link>

            <Link to="/sp/2020"> 
              <div className='menuLink'>
                2020
              </div>
            </Link>



        </div> 

      


   

      {/*<div className='andarwaladiv'>*/}
       
          <Routes>
            <Route exact path="2024" element={<Summer_2024 data = {spdata_2024}  />} />
            <Route exact path="2023" element={<Summer_2023 data = {spdata2023}  />} />
            <Route exact path="2022" element={<Summer_2022 data = {spdata2022} />} />
            <Route exact path="2021" element={<Summer_2021 data = {spdata_2021} />} />
            <Route exact path="2020" element={<Summer_2020 data = {spdata2020} />} />
        
          </Routes>
       {/*</div>*/}
     
       

</div>

</div>
  )
}

export default Summer

